module.exports = __webpack_public_path__ + "static/media/13ITC4.7b818e3b.jpg";